import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugin/vantui'  // 按需引入vantui
import "@/assets/fonts/iconfont.css"
import 'amfe-flexible'
import {Button} from 'vant';
import {Dialog} from 'vant';
import {Toast} from 'vant';
// 错误检测
import BJ_REPORT from 'badjs-report';

BJ_REPORT.init({
  id: 3,                                // 上报 id, 不指定 id 将不上报
  url: 'http://badjs.homolo.org/badjs',
  offline_url: 'http://badjs.homolo.org/badjs',        // 指定上报地址
  offline_auto_url: 'http://badjs.homolo.org/badjs',
  onReport: function (id, errObj) {
    console.log(errObj);
  },     // 当上报的时候回调。 id: 上报的 id, errObj: 错误的对象
  offlineLog: true,                   // 是否启离线日志 [默认 false]
});

Vue.config.errorHandler = (error, vm, i) => {
  BJ_REPORT.report(error);
  console.error(error);
};

Vue.config.warnHandler = (msg, vm, trace) => {
  BJ_REPORT.report({ msg: `warm:${msg}`, target: Object.keys(vm.$refs) + '', });
  console.warn(msg);
};

Vue.config.productionTip = false
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Toast);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
